import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UiState } from "./ui.types";

const initialState: UiState = {
    globalLoading: false,
};

const uiSlice = createSlice({
    name: "ui",
    initialState,
    reducers: {
        showLoader(state) {
            state.globalLoading = true;
        },
        hideLoader(state) {
            state.globalLoading = false;
        },
        showToast(
            state,
            action: PayloadAction<UiState["toast"]>
        ) {
            state.toast = action.payload;
        },
        clearToast(state) {
            state.toast = undefined;
        },
    },
});

export const {
    showLoader,
    hideLoader,
    showToast,
    clearToast,
} = uiSlice.actions;

export default uiSlice.reducer;
